import vi from "../types/vi";
import en from "../types/en";

export type Dictionary = typeof vi;

export const dictionaries = {
  vi,
  en: en as any as Dictionary,
} as const;

export type Locale = keyof typeof dictionaries;
